import DoneIcon from '@material-ui/icons/Done';
import MessageIcon from '@material-ui/icons/Message';

export const getAccountOpeningActions = (
  resource,
  completed,
  userCanUpdateActionItem,
  isAccountAi,
  isAccountFundingAi,
  isAccountRetitlingAi,
  actionItemOnClick,
  handleQuestionOnClick,
  onClose,
  defaultActionItems,
) => {
  const askMyPlannerListItem = {
    key: `ask-my-planner-${resource.id()}`,
    label: 'Ask My Planner',
    disabled: completed,
    onClick: (event) => {
      onClose(event);
      handleQuestionOnClick();
    },
    icon: MessageIcon,
    hidden: completed || !userCanUpdateActionItem,
  };

  const completeAccountOpeningListItem = {
    key: `complete-account-opening-${resource.id()}`,
    label: 'Complete Opening',
    disabled: completed,
    onClick: (event) => {
      onClose(event);
      actionItemOnClick();
    },
    icon: DoneIcon,
    hidden: completed || !userCanUpdateActionItem,
  };

  const completeAccountFundingListItem = {
    key: `complete-account-funding-${resource.id()}`,
    label: 'Complete Funding',
    disabled: completed,
    onClick: (event) => {
      onClose(event);
      actionItemOnClick();
    },
    icon: DoneIcon,
    hidden: completed || !userCanUpdateActionItem,
  };

  const completeAccountRetitlingListItem = {
    key: `complete-account-retitling-${resource.id()}`,
    label: 'Complete Retitling',
    disabled: completed,
    onClick: (event) => {
      onClose(event);
      actionItemOnClick();
    },
    icon: DoneIcon,
    hidden: completed || !userCanUpdateActionItem,
  };

  if (!isAccountAi && !isAccountFundingAi && !isAccountRetitlingAi) {
    return [
      askMyPlannerListItem,
      ...defaultActionItems,
    ];
  }

  if (isAccountRetitlingAi) {
    return [
      askMyPlannerListItem,
      completeAccountRetitlingListItem,
    ];
  }

  if (isAccountFundingAi) {
    return [
      askMyPlannerListItem,
      completeAccountFundingListItem,
    ];
  }

  return [
    askMyPlannerListItem,
    completeAccountOpeningListItem,
  ];
};
